import { render, staticRenderFns } from "./AddPacks.vue?vue&type=template&id=1ea75e8e"
import script from "./AddPacks.vue?vue&type=script&lang=js"
export * from "./AddPacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports